// made global function so it can be invoked from the html code.
window.UpdateHiddenFieldValue = function (checkbox, hiddenField) {
    try
    {
        if (document.getElementById(hiddenField).value) {
            var valueArray = document.getElementById(hiddenField).value.split(",");

            if (checkbox.checked && !valueArray.includes(checkbox.value)) {                    
                valueArray.push(checkbox.value);                    
            }

            if (!checkbox.checked && valueArray.includes(checkbox.value))
            {                    
                var valueArray = valueArray.filter(function (value, index, arr) { return value !== checkbox.value; });
            }

            document.getElementById(hiddenField).value = valueArray.join();
        }
        else
        {
            document.getElementById(hiddenField).value = checkbox.checked ? checkbox.value : "";
        }            
    }
    catch (e)
    {
        console.log(e.message);
    }
}